// Mock data for GEMS @ The Arts website

export const navLinks = [
  {
    key: 'nav.about',
    href: '/#about',
    isHash: true,
    children: [
      { key: 'nav.aboutOurStory', href: '/#about', isHash: true },
      { key: 'nav.supporters', href: '/supporters', isHash: false },
      { key: 'nav.pressReleases', href: '/press-releases', isHash: false },
      { key: 'nav.seasonArchive', href: '/summer-series', isHash: false },
    ],
  },
  { key: 'nav.programs', href: '/#programs', isHash: true },
  { key: 'nav.rentals', href: '/rentals', isHash: false },
  { key: 'nav.contact', href: '/contact', isHash: false },
];

export const heroAvatars = [
  'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=100&h=100&fit=crop&crop=face',
  'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face',
  'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face',
  'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face',
];

export const heroImages = [
  // Community walking together in downtown — Boston/Framingham streetscape
  'https://customer-assets-rejwkqb3.emergentagent.net/job_arts-gems-showcase/artifacts/dy04q9dq_01-1000134338-website.webp',
  // Youth field trip — New England Aquarium
  'https://customer-assets-rejwkqb3.emergentagent.net/job_arts-gems-showcase/artifacts/z6gclhc2_12-1000134314-website.webp',
  // Community members painting together at a GEMS event
  'https://customer-assets-rejwkqb3.emergentagent.net/job_arts-gems-showcase/artifacts/nzphz6uy_06-1000129312-website.webp',
  // GEMS team at Brighter Futures Music Festival
  'https://customer-assets-rejwkqb3.emergentagent.net/job_arts-gems-showcase/artifacts/67y1sket_19-1000129547-website.webp',
];

export const storyImage = 'https://customer-assets-rejwkqb3.emergentagent.net/job_arts-gems-showcase/artifacts/e4wejrxt_1000132814.webp';

export const storyValues = [
  { title: 'Creative Expression', desc: 'Space for all voices' },
  { title: 'Inclusive Access', desc: 'Programs for everyone' },
  { title: 'Community Led', desc: 'By and for neighbors' },
  { title: 'Youth Empowerment', desc: 'Future leaders' },
];

export const impactStats = [
  { number: '2,500+', label: 'Community Members' },
  { number: '150+', label: 'Annual Programs' },
  { number: '500+', label: 'Youth Served' },
  { number: '50+', label: 'Local Artists' },
];

export const summerCards = [
  {
    icon: 'Music',
    title: 'Music Festival',
    desc: 'A multi-day celebration featuring local artists, food vendors, and community performances in the heart of Framingham.',
    color: 'coral',
  },
  {
    icon: 'Palette',
    title: 'Weekly Arts Labs',
    desc: 'Hands-on creative workshops for all ages—painting, pottery, dance, and more led by local teaching artists.',
    color: 'teal',
  },
  {
    icon: 'Utensils',
    title: 'Community Markets',
    desc: "Weekly gatherings featuring local food vendors, artisans, and community organizations. A space to shop, eat, and connect.",
    color: 'dark',
  },
];

export const programs = [
  {
    key: 'arts',
    tab: 'Arts',
    title: 'Arts',
    desc: '',
    image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_arts-gems-showcase/artifacts/m7rdi4g0_16-1000131254-website.webp',
    bullets: [],
    cta: true,
    ctaHref: '/get-involved',
  },
  {
    key: 'enrichment',
    tab: 'Enrichment',
    title: 'Enrichment',
    desc: '',
    image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_arts-gems-showcase/artifacts/wltfbf2d_11-1000134318-website.webp',
    bullets: [],
    cta: true,
    ctaHref: '/get-involved',
  },
  {
    key: 'community',
    tab: 'Community',
    title: 'Community',
    desc: '',
    image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_arts-gems-showcase/artifacts/1xiplal1_14-1000132724-website.webp',
    bullets: [],
    cta: true,
    ctaHref: '/contact',
  },
  {
    key: 'space',
    tab: 'Space Rental',
    title: 'Rent Our Historic Space',
    desc: '',
    image: 'https://customer-assets.emergentagent.com/job_arts-gems-showcase/artifacts/1s6y5e7m_unnamed%20%2864%29.png',
    bullets: [],
    cta: true,
    ctaHref: '/rentals',
  },
];

export const testimonials = [
  {
    quote: "I started coming to Gems when I was 14. Now I'm 19 and leading my own workshops. This place doesn't just welcome youth\u2014it empowers us to lead.",
    role: 'Local Youth',
  },
  {
    quote: 'GEMS @ The Arts gave my daughter confidence I never knew she had. The programs didn\u2019t just teach her art\u2014they taught her to believe in herself and her voice.',
    role: 'Local Parent',
  },
  {
    quote: 'As a local artist, finding affordable studio space felt impossible. Gems not only gave me a place to create\u2014they connected me to students, collectors, and a community that genuinely supports local art.',
    role: 'Local Artist',
  },
  {
    quote: 'The community markets are where I sell my pottery and meet customers face-to-face. Gems built something special here\u2014a real creative economy that lifts everyone up.',
    role: 'Local Vendor',
  },
];

export const events = [
  {
    day: '15',
    month: 'JUN',
    time: '6:00 PM - 9:00 PM',
    title: 'Summer Kickoff Concert',
    desc: 'Launch the Brighter Futures series with live music, food trucks, and community celebration.',
    image: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=700&h=500&fit=crop',
    badge: 'coral',
  },
  {
    day: '22',
    month: 'JUN',
    time: '10:00 AM - 2:00 PM',
    title: 'Family Art Day',
    desc: 'All-ages creative workshops including mural painting, clay sculpting, and collaborative art projects.',
    image: 'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=700&h=500&fit=crop',
    badge: 'teal',
  },
  {
    day: '29',
    month: 'JUN',
    time: '11:00 AM - 4:00 PM',
    title: 'Community Market',
    desc: "Local vendors, live demonstrations, kids' activities, and the best of Framingham's creative economy.",
    image: 'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=700&h=500&fit=crop',
    badge: 'yellow',
  },
];

export const faqs = [
  {
    q: 'How can I enroll my child in youth programs?',
    a: 'Enrollment opens seasonally for our youth programs. You can join our mailing list to be notified of upcoming registration periods, or visit our Programs page to see current offerings. Scholarships and sliding scale fees are available to ensure all families can participate.',
  },
  {
    q: 'Can I rent the space for a private event?',
    a: 'Absolutely! Our historic venue is available for weddings, meetings, performances, and celebrations. We offer special rates for community organizations and nonprofits. Visit our Rentals page to submit an inquiry or schedule a tour.',
  },
  {
    q: 'How can local artists get involved?',
    a: 'We welcome local artists through multiple pathways: teaching opportunities, exhibition space, artist residencies, and vendor spots at our community markets. Fill out our artist interest form to learn about current opportunities and join our creative network.',
  },
  {
    q: 'Are your programs accessible to people with disabilities?',
    a: 'Yes\u2014accessibility is core to our mission. Our building is fully ADA compliant, and we work with participants to accommodate individual needs. Please contact us in advance of any program so we can ensure you have the best possible experience.',
  },
  {
    q: 'How can I support GEMS @ The Arts?',
    a: 'There are many ways to support our work: make a donation, become a monthly sustainer, sponsor an event or program, volunteer your time, or spread the word to friends and neighbors. Every contribution helps us keep our programs accessible and impactful.',
  },
];

export const interestOptions = [
  'Youth Programs',
  'Space Rental',
  'Volunteering',
  'Donating / Sponsorship',
  'Becoming a Vendor',
  'Artist Opportunities',
  'General Inquiry',
];

export const footerLinks = {
  offer: [
    { label: 'Arts', href: '/#programs' },
    { label: 'Enrichment', href: '/summer-series' },
    { label: 'Community', href: '/#programs' },
    { label: 'Space Rental', href: '/rentals' },
  ],
  involved: [
    { label: 'Volunteer', href: '/get-involved' },
    { label: 'Donate', href: '/donate' },
    { label: 'Become a Vendor', href: '/get-involved' },
    { label: 'Sponsor an Event', href: '/donate' },
    { label: 'Partner With Us', href: '/get-involved' },
  ],
};

// Summer Series page content
export const summerHeroImage = 'https://images.unsplash.com/photo-1472653816316-3ad6f10a6592?w=1600&h=900&fit=crop';
export const summerGalleryImages = [
  'https://images.unsplash.com/photo-1520095972714-909e91b038e5?w=800&h=600&fit=crop',
  'https://images.unsplash.com/photo-1565103420311-8cbbc3cd87b8?w=800&h=600&fit=crop',
  'https://images.unsplash.com/photo-1442504028989-ab58b5f29a4a?w=800&h=600&fit=crop',
  'https://images.unsplash.com/photo-1604200657090-ae45994b2451?w=800&h=600&fit=crop',
];

export const summerSeriesEvents = [
  {
    id: 'kickoff',
    icon: 'Sun',
    color: 'coral',
    title: 'Summer Kick Off Celebration',
    date: 'June 26',
    time: '1:00 PM',
    partner: 'In collaboration with Project Bread & MetroWest YMCA',
    desc: 'Launch the season with food, music, and community pride. Free and open to all.',
  },
  {
    id: 'market',
    icon: 'ShoppingBasket',
    color: 'teal',
    title: 'Mobile Market Mondays + Live Music',
    date: 'Mondays',
    time: '3:30 PM – 5:30 PM',
    partner: '8-Week Summer Series',
    desc: 'Weekly fresh-food access paired with live music and neighborly hangs.',
  },
  {
    id: 'park',
    icon: 'TreeDeciduous',
    color: 'yellow',
    title: 'Daily Park Enrichment Experience',
    date: 'July 6 – August 24',
    time: '11:00 AM – 2:00 PM',
    partner: 'Weekday programming',
    desc: 'Daily youth enrichment: arts, games, lunch, and joy in the park.',
  },
  {
    id: 'joy',
    icon: 'Sparkles',
    color: 'coral',
    title: 'Joy Kick Off Celebration Night',
    date: 'Friday, July 31',
    time: '6:00 PM',
    partner: 'Intimate — limited capacity',
    desc: 'A leadership, supporter, and community celebration kicking off festival weekend.',
  },
  {
    id: 'festival',
    icon: 'Music',
    color: 'teal',
    title: 'Brighter Futures Music Festival',
    date: 'August 1 & 2',
    time: 'All weekend',
    partner: 'Headline weekend',
    desc: 'Two days of music, food, art, and community joy in downtown Framingham.',
    featured: true,
  },
  {
    id: 'backtoschool',
    icon: 'Backpack',
    color: 'yellow',
    title: 'Back to School Extravaganza',
    date: 'August 16',
    time: 'Day-long event',
    partner: 'For students & families',
    desc: 'Backpack giveaways, school-readiness resources, performances, and family fun.',
  },
];

export const getInvolvedWays = [
  {
    icon: 'CalendarHeart',
    title: 'Attend an Event',
    desc: 'Show up, bring a friend, and experience the joy of community at our markets, concerts, and workshops.',
    cta: 'View Events',
    href: '/#events',
    color: 'coral',
  },
  {
    icon: 'HandHeart',
    title: 'Volunteer',
    desc: 'Lend your time and skills. From event setup to youth mentoring, every hour strengthens our community.',
    cta: 'Sign Up to Volunteer',
    href: '/get-involved#volunteer',
    color: 'teal',
  },
  {
    icon: 'Handshake',
    title: 'Become a Partner',
    desc: 'Organizations, nonprofits, and local businesses\u2014collaborate with us on programs, events, and outreach.',
    cta: 'Partner With Us',
    href: '/get-involved#partner',
    color: 'yellow',
  },
  {
    icon: 'Heart',
    title: 'Donate or Sponsor',
    desc: 'Your gift keeps our programs free and accessible. Become a sustainer or sponsor a season of joy.',
    cta: 'Support Our Work',
    href: '/donate',
    color: 'coral',
  },
];

export const communityImages = [
  'https://images.unsplash.com/photo-1618521715147-29e4b97e2ebd?w=800&h=600&fit=crop',
  'https://images.unsplash.com/photo-1531844251246-9a1bfaae09fc?w=800&h=600&fit=crop',
  'https://images.unsplash.com/photo-1517456793572-1d8efd6dc135?w=800&h=600&fit=crop',
  'https://images.unsplash.com/photo-1502086223501-7ea6ecd79368?w=800&h=600&fit=crop',
  'https://images.unsplash.com/photo-1630139026564-4a2bf5670879?w=800&h=600&fit=crop',
  'https://images.unsplash.com/photo-1588072432836-e10032774350?w=800&h=600&fit=crop',
  'https://images.unsplash.com/photo-1597524678053-5e6fef52d8a3?w=800&h=600&fit=crop',
];

export const venueImages = [
  'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=900&h=700&fit=crop',
  'https://images.unsplash.com/photo-1527529482837-4698179dc6ce?w=900&h=700&fit=crop',
  'https://images.unsplash.com/photo-1497366216548-37526070297c?w=900&h=700&fit=crop',
];

export const eventTypes = [
  'Wedding / Celebration',
  'Workshop / Class',
  'Performance / Concert',
  'Meeting / Conference',
  'Birthday Party',
  'Community Gathering',
  'Photo / Film Shoot',
  'Other',
];

export const referralOptions = [
  'Friend / Word of Mouth',
  'Social Media (Instagram / Facebook)',
  'Google Search',
  'Community Event',
  'Local Partner Org',
  'Press / News Article',
  'Other',
];

export const GIVEBUTTER_URL = 'https://givebutter.com/campaign-for-summer-enrichment-dezxut';

// Brand assets uploaded by client
export const LOGO_URL = '/gems-logo.png';
export const VENUE_COLLAGE = 'https://customer-assets.emergentagent.com/job_arts-gems-showcase/artifacts/1s6y5e7m_unnamed%20%2864%29.png';
export const PHOTO_LEADERSHIP = 'https://customer-assets.emergentagent.com/job_arts-gems-showcase/artifacts/5ep9egj0_unnamed%20%2821%29.jpg';
export const PHOTO_CEILI = 'https://customer-assets.emergentagent.com/job_arts-gems-showcase/artifacts/1iszcdk8_unnamed%20%2820%29.jpg';
export const PHOTO_MURAL = 'https://customer-assets.emergentagent.com/job_arts-gems-showcase/artifacts/twrvirwo_unnamed%20%2819%29.jpg';


// --- Brighter Futures / Joy assets ---
// People-first imagery: music, dance, youth, multigenerational moments, real connection.
export const joyMomentImages = [
  // Big tile — real GEMS community selfie moment
  'https://customer-assets-rejwkqb3.emergentagent.net/job_arts-gems-showcase/artifacts/o3szdkrj_1000132789.webp',
  // Outdoor crowd celebration — Brighter Futures Music Festival crew selfie
  'https://customer-assets-rejwkqb3.emergentagent.net/job_arts-gems-showcase/artifacts/wpvs78iz_05-1000129551-website.webp',
  // Kids doing sidewalk chalk art at GEMS
  'https://customer-assets-rejwkqb3.emergentagent.net/job_arts-gems-showcase/artifacts/xys4o3v8_15-1000131649-website.webp',
  // Youth entrepreneurs at Dulces vendor tent
  'https://customer-assets-rejwkqb3.emergentagent.net/job_arts-gems-showcase/artifacts/7torghmg_18-1000130619-website.webp',
  // Real GEMS media/story moment — "Your Story Starts Here"
  'https://customer-assets-rejwkqb3.emergentagent.net/job_arts-gems-showcase/artifacts/dej8kpix_1000132743.webp',
  // Hand on guitar / making music
  'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=900&h=900&fit=crop',
];

// Wide cinematic image used by the Summer Series hero
export const ssHeroWide = 'https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=1800&h=1000&fit=crop';

// Past "moments" photos for the Behind the Joy strip
export const behindTheJoyImages = [
  'https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?w=800&h=1000&fit=crop',
  'https://images.unsplash.com/photo-1506157786151-b8491531f063?w=800&h=600&fit=crop',
  'https://images.unsplash.com/photo-1521336575822-6da63fb45455?w=800&h=1000&fit=crop',
  'https://images.unsplash.com/photo-1531058020387-3be344556be6?w=800&h=600&fit=crop',
];

// Voices from the community — placeholder; admin can edit later via CMS
// Testimonial slot metadata. The `quote`, `name`, and `role` for each voice
// are looked up via i18n at render time via keys: home.voices.v<n>.*
// This keeps names/roles editable in translations.js without a data change.
export const joyVoices = [
  { slot: 'v1' },
  { slot: 'v2' },
  { slot: 'v3' },
];

// Sponsorship tiers — placeholder, editable later via CMS
export const sponsorshipTiers = [
  {
    name: 'Joy Builder',
    amount: '$500+',
    color: 'teal',
    perks: [
      'Recognition on the Summer Series web page',
      'Two tickets to the Joy Kick Off Celebration Night',
      'Social media thank-you',
    ],
  },
  {
    name: 'Festival Friend',
    amount: '$2,500+',
    color: 'coral',
    featured: true,
    perks: [
      'Logo on all festival print + digital materials',
      'On-stage thank-you during festival weekend',
      'Booth space at the Brighter Futures Music Festival',
      'Six tickets to Joy Kick Off Night + VIP lounge access',
    ],
  },
  {
    name: 'Brighter Futures Sponsor',
    amount: '$10,000+',
    color: 'yellow',
    perks: [
      'Headline sponsor billing across the entire series',
      'Custom on-site brand activation (booth, stage, banner)',
      'Year-round recognition + impact report',
      'Co-branded community giveback opportunity',
    ],
  },
];
